import { Api } from 'utils';

class NotificationService {
  static admin = {
    get: async (params?: any) => Api.createResponse('admin/notifications/get', params),
    detail: async (params?: any) => Api.createResponse('admin/notifications/detail', params),
    recipients: async (params?: any) =>
      Api.createResponse('admin/notifications/recipients', params),
    candidates: async (params?: any) =>
      Api.createResponse('admin/notifications/candidates', params),
    send: async (params?: any) => Api.createResponse('admin/notifications/send', params),
  };

  // Bandeja de comunicados del usuario autenticado (cliente/abogado) -- mismo
  // endpoint que ya consume la app móvil (api/app/notifications/*), acá se
  // reutiliza tal cual para que "Legalmente" aparezca como un chat más en el
  // panel web (ver client/chat/chat.tsx).
  static client = {
    get: async (params?: any) => Api.createResponse('app/notifications/get', params),
    detail: async (params?: any) => Api.createResponse('app/notifications/detail', params),
    read: async (params?: any) => Api.createResponse('app/notifications/read', params),
    unreadCount: async (params?: any) =>
      Api.createResponse('app/notifications/unread-count', params),
  };
}

export default NotificationService;
